import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractApproveFileApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contractApproveFile'
  }

}